import React, { useState, useEffect } from 'react';
import { Footer, Header } from '../components/layout';
import { backgroundDark, backgroundLight } from "../assets/images";
import { useStateContext } from '../context/ContextProvider';
import { useTranslation } from 'react-i18next';
import GradiantButton from '../components/layout/GradiantButton';
import { IoIosSend } from "../components/icons";

export const Products_Details = () => {
    const { currentMode, currentLang } = useStateContext();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        subject: "",
        message: "",
    });
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
    const { t } = useTranslation();



    const handleSubmit = async (e) => {
        e.preventDefault();

    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <div className='w-full'
            style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
            <Header activeLink={"/ContactUs"} />




            <div className="container pt-24 pd:mt-32 lg:pt-36 ">




                <div className="w-full mx-auto bg-light-glass1 dark:bg-dark-glass1 backdrop-blur-xl rounded-lg shadow dark:border md:mt-0 sm:max-w-md border border-light-strock  xl:p-10 p-5">
                    <h4 className='h5 text-center text-light-blue dark:text-dark-title '>
                        {t("We are pleased to have you contact us.")}
                    </h4>
                    <p className='body-2  text-center text-light-subtitle dark:text-dark-subtitle mb-6 md:mb-8'>  {t("We do our utmost to serve you.")}</p>
                    <iframe className="clickup-embed clickup-dynamic-height"
                        src="https://forms.clickup.com/90181050825/f/2kzkb8e9-23238/7UW67XTRYGY8WYC8PL" width="100%" height="780"
                        style={{ background: "transparent", border: "1px solid #ccc" }} ></iframe>


                    {/*                     <form*/}
                    {/*  onSubmit={handleSubmit}*/}
                    {/*  className="gap-2"*/}
                    {/*>*/}

                    {/*     <Label*/}
                    {/*    labelText="Full Name"*/}
                    {/*    value={formData.name}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    required={true}*/}
                    {/*    type="text"*/}
                    {/*    name="name"*/}
                    {/*  />*/}

                    {/*                     <Label*/}
                    {/*    labelText="Email"*/}
                    {/*    value={formData.email}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    required={true}*/}
                    {/*    type="email"*/}
                    {/*    name="email"*/}
                    {/*  />*/}
                    {/*     <Label*/}
                    {/*    labelText="Phone Number"*/}
                    {/*    value={formData.phoneNumber}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    required={true}*/}
                    {/*    type="number"*/}
                    {/*    name="phoneNumber"*/}
                    {/*  />*/}
                    {/*    <Label*/}
                    {/*    labelText="Subject"*/}
                    {/*    value={formData.subject}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    required={true}*/}
                    {/*    type="text"*/}
                    {/*    name="name"*/}
                    {/*  />*/}
                    {/*   <TextArea*/}
                    {/*     labelText="Message"*/}
                    {/*     value={formData.message}*/}
                    {/*     onChange={handleChange}*/}
                    {/*     required={true}*/}
                    {/*     type="text"*/}
                    {/*     name="name"/>*/}
                    {/*     </form>*/}
                    {/*<div className="mt-4 w-full flex items-center justify-center">*/}
                    {/*    <GradiantButton textSize={"text-sm font-kufi"} text={"Send"} icon={<IoIosSend />} />*/}
                    {/*</div>*/}

                </div></div>
            <Footer />
        </div>
    );
};
